class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day")
            .replace(/ /g, '')
            .split(",");
        this.numbDateStart = this.getAttribute("data-estimate-start");
        this.numbDateEnd = this.getAttribute("data-estimate-end");
        this.targetTime = this.getAttribute("data-time");

        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');
        this.orderedEl = this.querySelector('[data-ordered-delivery]');
        this.dispatchStartEl = this.querySelector('[data-dispatch-start]');
        this.dispatchEndEl = this.querySelector('[data-dispatch-end]');
        this.iso_code = document.documentElement.lang;

        this.productDeliveryTime();

        const countdown = this.countdownToTime(this.targetTime);
        if (this.hr) this.hr.innerHTML = countdown.hours;
        if (this.mins) this.mins.innerHTML = countdown.minutes;

        setInterval(() => {
            const countdown = this.countdownToTime(this.targetTime);
            if (this.hr) this.hr.innerHTML = countdown.hours;
            if (this.mins) this.mins.innerHTML = countdown.minutes;
        }, 1000);
    }

    checkAllExcludeDays(excludedDays) {
        const now = new Date();
        const deliveryDateTime = new Date(now);

        for (let day of excludedDays) {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) return true;
        }

        return false;
    }

    nextValidDate(baseDate, excludedDays) {
        const date = new Date(baseDate);
        const excludedSet = new Set(excludedDays);
        while (excludedSet.has(['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'][date.getDay()])) {
            date.setDate(date.getDate() + 1);
        }
        return date;
    }

    productDeliveryTime() {
        const orderDlvr = document.querySelectorAll("[data-delivery-time]");
        if (orderDlvr.length === 0) return;

        const todayDate = new Date();
        const dispatchBaseDate = this.nextValidDate(todayDate, this.excludedDays);
        let startDay = this.excludeDays(this.excludedDays, this.numbDateStart, dispatchBaseDate);
        let endDay = this.excludeDays(this.excludedDays, this.numbDateEnd, dispatchBaseDate);

        const formattedStartDate = this.formatDate(startDay, this.formatString);
        const formattedEndDate = this.formatDate(endDay, this.formatString);
        const formattedToday = this.formatDate(todayDate.toLocaleDateString('en-US'), this.formatString);
        const formattedDispatchBase = this.formatDate(dispatchBaseDate.toLocaleDateString('en-US'), this.formatString);

        orderDlvr.forEach(el => {
            const startEl = el.querySelector('[data-start-delivery]');
            const endEl = el.querySelector('[data-end-delivery]');
            const orderedEl = el.querySelector('[data-ordered-delivery]');
            const dispatchStartEl = el.querySelector('[data-dispatch-start]');
            const dispatchEndEl = el.querySelector('[data-dispatch-end]');
            
            if (startEl) startEl.innerHTML = formattedStartDate;
            if (endEl) endEl.innerHTML = formattedEndDate;
            if (orderedEl) orderedEl.innerHTML = formattedToday;
            if (dispatchStartEl) dispatchStartEl.innerHTML = formattedDispatchBase;
            if (dispatchEndEl) dispatchEndEl.innerHTML = formattedStartDate;
        });
    }

    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const locale = window.iso_code || 'en-US';
        const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' }),
            dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit' }),
            month = date.toLocaleDateString(locale, { month: 'short' }),
            monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
            year = date.toLocaleDateString(locale, { year: 'numeric' });
        const dayNumber = parseInt(dayOfMonth, 10);
        const ordinal = (n) => {
            if (n > 3 && n < 21) return `${n}th`;
            switch (n % 10) {
                case 1: return `${n}st`;
                case 2: return `${n}nd`;
                case 3: return `${n}rd`;
                default: return `${n}th`;
            }
        };
        const dayWithOrdinal = ordinal(dayNumber);

        const formattedDate = formatString
            .replace('d', dayOfWeek)
            .replace('DDth', dayWithOrdinal)
            .replace('DD', dayOfMonth)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('YYYY', year);

        return formattedDate;
    }

    excludeDays(excludedDays, dataRange, baseDate) {
        const deliveryDateTime = new Date(baseDate || new Date());

        deliveryDateTime.setDate(deliveryDateTime.getDate() + parseInt(dataRange));
        excludedDays.forEach(day => {
            const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
            if (deliveryDateTime.getDay() === dayIndex) {
                deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
            }
        });

        return deliveryDateTime.toLocaleDateString('en-US');
    }

    countdownToTime(targetTime) {
        const currentTime = new Date(),
            targetTimeString = `${currentTime.toDateString()} ${targetTime}`,
            targetDateTime = new Date(targetTimeString);

        if (targetDateTime < currentTime) targetDateTime.setDate(targetDateTime.getDate() + 1);

        const remainingTime = targetDateTime - currentTime;

        const hours = Math.floor(remainingTime / (1000 * 60 * 60)),
            minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

        return { hours, minutes };
    }
}
customElements.define('delivery-time', DeliveryTime);
